/**
 * Auth package locale keys — mirrors the subset of formError.json keys
 * used by the auth package. Avoids importing from the app's types/locales.
 */

const AUTH_NAMESPACE = 'formError' as const;

const prefix = (key: string) => `${AUTH_NAMESPACE}:${key}` as const;

export const AUTH_LOCALE_KEYS = {
  INVALID_PASSWORD:           prefix('invalid_password'),
  INVALID_PASSWORD_FORMAT:    prefix('invalid_password_format'),
  INVALID_EMAIL:              prefix('invalid_email'),
  INVALID_CODE:               prefix('invalid_code'),
  INVALID_PHONE:              prefix('invalid_phone'),
  EXPIRED_CODE:               prefix('expired_code'),
  EMAIL_TAKEN:                prefix('email_taken'),
  OTHER:                      prefix('other'),
  PASSWORD_CHANGED_SUCCESS:   prefix('password_changed_success'),
  PASSWORD_RESET_EMAIL_SENT:  prefix('password_reset_email_sent'),
  RESET_TOKEN_INVALID:        prefix('reset_token_invalid'),
  INFO_CHANGED_SUCCESS:       prefix('info_changed_success'),
  VALIDATION_REQUEST_FAILED:  prefix('validation_request_failed'),
  VALIDATION_ERROR_MESSAGE:   prefix('validation_error_message'),
  ACCOUNT_CONFIRMATION_FAILED: prefix('account_confirmation_failed'),
  ACCOUNT_DELETE_FAILED:      prefix('account_delete_failed'),
  ACCOUNT_DELETED_SUCCESS:    prefix('account_deleted_success'),
  PRIVATE_EMAIL_EXPOSED:      prefix('private_email_exposed'),
} as const;
